import { Box, Grid, Typography } from "@material-ui/core"
import { AccordionSaurus } from "views/components/accordions/accordion-saurus/accordion-saurus"
import { memo, useState, useMemo, useCallback } from "react"
import { useStyles } from "./accordion-historico-atualizacoes-styles"
import { toDateString } from "utils/to-date"
import { HistoricoDataLogsProps, HistoricoLogVersaoProps } from "../../historico-atualizacoes-list-data"
import { LogLogModel } from "model/api/gestao/clickup/log-log-model"
import { useThemeQueries } from "views/theme"
import { CardHistoricoAtualizacoes } from "views/components/cards/card-historico-atualizacoes/card-historico-atualizacoes"
import { DataVersao } from "./components/data-versao/data-versao"

interface AccordionHistoricoAtualizacoesProps {
    backlog: HistoricoDataLogsProps
    index: number
}

export const AccordionHistoricoAtualizacoesData = memo(({ backlog, index }: AccordionHistoricoAtualizacoesProps) => {
    const classes = useStyles()
    const { theme: { palette } } = useThemeQueries()

    const [expanded, setExpanded] = useState(() => index < 5);

    // Memoiza a função de alternar o estado de expansão
    const handleExpansionChange = useCallback(() => {
        setExpanded(prev => !prev);
    }, []);

    // Memoiza as datas únicas das tarefas
    const tarefaVersao = useMemo(() =>
        Array.from(new Set(backlog.logs.map(log => log.versao.id)))
        , [backlog.logs]);

    // Memoiza o mapeamento das tarefas por data
    const tarefasPorVersao = useMemo(() => {
        const mapa = new Map();
        tarefaVersao.forEach(logVersao => {
            mapa.set(
                logVersao,
                backlog.logs
                    .filter(tarefa => tarefa.versao.id === logVersao)
                    .sort((a, b) => new Date(b.data).getTime() - new Date(a.data).getTime())
            );
        });
        return mapa as Map<number, LogLogModel[]>;
    }, [backlog.logs, tarefaVersao]);


    return (
        <Box pt={index > 0 ? 1 : 0}>
            <AccordionSaurus
                labelPrimary={
                    <Typography className={classes.labelPrimary}>
                        <span>Desenvolvido em: {toDateString(backlog.data)}</span>
                    </Typography>
                }
                expanded={expanded}
                showDivider
                colorExpand={palette.primary.main}
                tipoExpand="bold"
                classesTitle={classes.titleAccordion}
                onChange={handleExpansionChange}
            >
                {expanded && (
                    <Grid container spacing={2}>
                        {Array.from(tarefasPorVersao.keys()).map(log => {
                            const tarefas = tarefasPorVersao.get(log) ?? [];
                            const versaoObj: HistoricoLogVersaoProps | undefined = backlog.logs.find(v => v.versao.id === log)
                            return (
                                <Grid item xs={12} key={log}>
                                    <Grid className={classes.tarefasContainer}>
                                        <Grid container>
                                            <Grid item xs={"auto"}>
                                                <Typography variant='body1' className={classes.titulo}>
                                                    • {versaoObj?.versao.descricao}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs className={classes.contentDataVersao}>
                                                <DataVersao data={versaoObj?.versao.data_alfa ?? ''} tipo='alfa' />
                                                <DataVersao data={versaoObj?.versao.data_beta ?? ''} tipo='beta' />
                                                <DataVersao data={versaoObj?.versao.data_estavel ?? ''} tipo='estavel' />
                                            </Grid>
                                        </Grid>
                                        <Grid className={classes.tarefas}>
                                            {tarefas.map((tarefa) => {
                                                return (
                                                    <CardHistoricoAtualizacoes
                                                        descricao={tarefa.descricao}
                                                        link_clickup={tarefa.link_clickup}
                                                        tipo_log={tarefa.tipo_log}
                                                        titulo={tarefa.titulo}
                                                        key={tarefa.id}
                                                    />
                                                )
                                            })}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )
                        })}
                    </Grid>
                )
                }
            </AccordionSaurus>
        </Box>
    )
})

AccordionHistoricoAtualizacoesData.displayName = 'AccordionHistoricoAtualizacoesData'